/**
 * Generate LocalBusiness schema for a salon
 * @param {Object} salon - Salon data
 * @returns {Object} JSON-LD schema
 */
export function generateSalonSchema(salon) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": salon.nom_societe || salon.nom,
    "image": salon.logo || salon.image,
    "url": `https://bookmysalon.com/etablissement/${salon.slug}`,
    "@id": `https://bookmysalon.com/etablissement/${salon.slug}`,
    "telephone": salon.telephone,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": salon.adresse,
      "addressLocality": salon.city || salon.ville,
      "addressCountry": "FR"
    },
    "priceRange": "€€"
  };

  // Add geo coordinates if available
  if (salon.latitude && salon.longitude) {
    schema.geo = {
      "@type": "GeoCoordinates",
      "latitude": salon.latitude,
      "longitude": salon.longitude
    };
  }

  // Add aggregate rating if available
  if (salon.googleRating) {
    schema.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": salon.googleRating,
      "reviewCount": salon.googleReviewsCount || 0
    };
  }

  return schema;
}

/**
 * Inject structured data into the document head
 * @param {Object} schemaObject - JSON-LD schema object
 */
export function injectStructuredData(schemaObject) {
  // Remove existing structured data
  const existing = document.getElementById('structured-data');
  if (existing) {
    existing.remove();
  }

  // Create new script tag
  const script = document.createElement('script');
  script.id = 'structured-data';
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schemaObject, null, 2);
  document.head.appendChild(script);
}

/**
 * Generate BreadcrumbList schema
 * @param {Array} breadcrumbs - Array of {name, path} objects
 * @returns {Object} JSON-LD schema
 */
export function generateBreadcrumbSchema(breadcrumbs) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": `https://bookmysalon.com${crumb.path}`
    }))
  };
}

/**
 * Generate ItemList schema for a list of salons
 * @param {Array} salons - Array of salon objects
 * @param {String} name - Name of the list
 * @returns {Object} JSON-LD schema
 */
export function generateSalonListSchema(salons, name) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": name,
    "numberOfItems": salons.length,
    "itemListElement": salons.map((salon, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "url": `https://bookmysalon.com/etablissement/${salon.slug}`
    }))
  };
}
